export default __webpack_public_path__ + "fonts/366AC1_0_0.eot";